<template>
  <div id="google-map"></div>
</template>

<script>
/* global google */

import { without } from 'lodash'
import googleMapsLibrary from '@/utils/google-maps-library'

export default {
  name: 'google-map',
  data: function () {
    return {
      map: {},
      drawingManager: {},
      polygons: [],
      markers: [],
      polylines: []
    }
  },
  mounted: function () {
    googleMapsLibrary.once('ready', () => {
      this.createMap()
      this.$emit('ready')
    })
    googleMapsLibrary.load()
  },
  methods: {
    createMap: function () {
      this.map = new google.maps.Map(document.getElementById('google-map'), {
        center: {
          lat: 6.265666,
          lng: -75.574995
        },
        zoom: 14,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        }
      })
      this.drawingManager = this.turnOnDrawingManager()
    },
    turnOnDrawingManager: function () {
      const drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: false
      })
      google.maps.event.addListener(drawingManager, 'polygoncomplete', (overlay) => {
        const overlayPath = overlay.getPath().getArray()
        this.$emit('polygon-overlay-created', overlayPath)
        overlay.setMap(null)
        this.drawingManager.setDrawingMode(null)
      })
      google.maps.event.addListener(drawingManager, 'markercomplete', (marker) => {
        const position = marker.getPosition()
        this.$emit('marker-created', position)
        marker.setMap(null)
        this.drawingManager.setDrawingMode(null)
      })
      google.maps.event.addListener(drawingManager, 'polylinecomplete', (overlay) => {
        const overlayPath = overlay.getPath().getArray()
        this.$emit('polyline-overlay-created', overlayPath)
        overlay.setMap(null)
        this.drawingManager.setDrawingMode(null)
      })
      drawingManager.setMap(this.map)
      return drawingManager
    },
    drawPolygon: function () {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON)
    },
    drawPolyline: function () {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE)
    },
    drawMarker: function () {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER)
    },
    panTo: function (position) {
      this.map.panTo(position)
    },
    setGeometryToMap: function (geometry) {
      if (geometry instanceof google.maps.Polyline) {
        geometry.type = 'Polyline'
        this.polylines.push(geometry)
      } else if (geometry instanceof google.maps.Marker) {
        geometry.type = 'Marker'
        this.markers.push(geometry)
      } else if (geometry instanceof google.maps.Polygon) {
        geometry.type = 'Polygon'
        this.polygons.push(geometry)
      } else {
        throw new Error('Unknown geometry type')
      }
      const emitClickEvent = (geometry) => {
        this.$emit('geometry-clicked', geometry)
      }
      geometry.addListener('click', function () {
        emitClickEvent(this)
        event.stopPropagation()
      })
      geometry.setMap(this.map)
    },
    removeMarkers: function () {
      for (const marker of this.markers) {
        marker.setMap(null)
        this.markers = without(this.markers, marker)
      }
    },
    removePolygons: function () {
      for (const polygon of this.polygons) {
        polygon.setMap(null)
        this.polygons = without(this.polygons, polygon)
      }
    },
    removePolylines: function () {
      for (const polyline of this.polylines) {
        polyline.setMap(null)
        this.polylines = without(this.polylines, polyline)
      }
    },
    animateMarker: function (markerId) {
      this.markers.some(marker => {
        if (markerId === marker.id) {
          marker.setAnimation(google.maps.Animation.BOUNCE)
        } else {
          marker.setAnimation(null)
        }
        return markerId === marker.id
      })
    },
    createPolygon: function ({ polygonOptions }) {
      return new google.maps.Polygon(polygonOptions)
    },
    createPolyline: function ({ polylineOptions }) {
      return new google.maps.Polyline(polylineOptions)
    },
    createMarker: function ({ markerOptions }) {
      return new google.maps.Marker(markerOptions)
    }
  }
}
</script>

<style lang="sass" scoped>
#google-map
  height: 100%
  margin: 0
  padding: 0
</style>



// WEBPACK FOOTER //
// src/components/Maps/Google.vue